import { useSearchParams } from 'react-router';

export const APP_KEY_SEARCH_PARAM = 'appKey';

export function useAppKey() {
  const [params] = useSearchParams();

  return {
    appKey: params.get(APP_KEY_SEARCH_PARAM),
  };
}
